import React, { useState } from "react";
import ServiceSelectTag from "./select/ServiceSelectTag";

export default function ServiceBasedAppointment({ AllServicesListing }) {
  // FORM STATE FALSE IS NOT SUBMITTED
  const [formState, setFormState] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    serviceIntrested: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const formSubmittion = (e) => {
    console.log(formData);
  };
  return (
    // FORM WITH A LEFT SIDE CONTENT
    <div className="prt-page-title-row style2">
      <div className="prt-page-title-row-inner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6">
              <div className="prt-page-title-row-heading">
                <div className="page-title-heading">
                  <h3>We are here for your care</h3>
                  <h2 className="title">
                    Authentic Ayurvedic Healing & Wellness
                  </h2>
                </div>
                <div className="page-title-desc">
                  <p>
                    Rooted in India’s ancient wisdom, Bharat Dhara offers
                    holistic Ayurvedic consultations, Panchakarma detox,
                    rejuvenation therapies, yoga, and lifestyle guidance —
                    helping you restore balance, vitality, and inner peace.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="prt-pagetitle-appointment-block res-991-mt-40">
                <form
                  action="#"
                  className="query_form-1 wrap-form clearfix"
                  method="post"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <span className="text-input">
                        <input
                          name="name"
                          type="text"
                          placeholder="Name *"
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-6">
                      <span className="text-input">
                        <input
                          name="email"
                          type="email"
                          placeholder="Email *"
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-6">
                      <span className="text-input">
                        <input
                          name="phone"
                          type="phone"
                          placeholder="Phone *"
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </div>
                    <ServiceSelectTag
                      ServiceNames={AllServicesListing}
                      handleChange={handleChange}
                      value={formData.serviceIntrested}
                    />
                    <div className="col-md-12">
                      <span className="text-input">
                        <input
                          name="date"
                          type="date"
                          placeholder="Select Date *"
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-12">
                      <span className="text-input">
                        <textarea
                          name="message"
                          rows="3"
                          placeholder="Message *"
                          onChange={handleChange}
                          required
                        ></textarea>
                      </span>
                    </div>
                    <div className="col-md-12 mt-20">
                      <button
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                        type="submit"
                        onClick={formSubmittion}
                      >
                        Make an appointment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
